import { BusinessSearchResult } from '../../../types';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { FIELD_ABR_BASE_PATH } from '../constants/fieldBasePath';

export const searchBusinessByName = async (
  constructGet: ConstructGet,
  value: string,
): Promise<NonPaginatedResponse<BusinessSearchResult[]> | undefined> =>
  constructGet<NonPaginatedResponse<BusinessSearchResult[]>>(
    `${FIELD_ABR_BASE_PATH}/search`,
    { params: { value } },
  );
